export type Lang = "en" | "fr";

export function detectLang(): Lang {
  if (typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("fr")) {
    return "fr";
  }
  return "en";
}

type Str = Record<Lang, string>;

// UI chrome strings. Recipe content itself comes already-translated from the API.
export const T = {
  searchPlaceholder: { en: "Search recipes…", fr: "Rechercher une recette…" },
  allCategories: { en: "All categories", fr: "Toutes les catégories" },
  recipes: { en: "recipes", fr: "recettes" },
  servingOne: { en: "serving", fr: "pers." },
  servingMany: { en: "servings", fr: "pers." },
  recipe: { en: "recipe", fr: "recette" },
  loading: { en: "Loading…", fr: "Chargement…" },
  resultsFor: { en: "for", fr: "pour" },
  clear: { en: "Clear", fr: "Effacer" },
  noMatch: { en: "No recipes match these filters.", fr: "Aucune recette ne correspond à ces filtres." },
  none: { en: "No recipes found.", fr: "Aucune recette trouvée." },
  failed: { en: "Failed to load recipes:", fr: "Échec du chargement :" },
  prev: { en: "Previous", fr: "Précédent" },
  next: { en: "Next", fr: "Suivant" },
  page: { en: "Page", fr: "Page" },
  of: { en: "of", fr: "sur" },
  back: { en: "Back to recipes", fr: "Retour aux recettes" },
  ingredients: { en: "Ingredients", fr: "Ingrédients" },
  steps: { en: "Steps", fr: "Étapes" },
  notes: { en: "Notes", fr: "Notes" },
  metric: { en: "Metric", fr: "Métrique" },
  imperial: { en: "Imperial", fr: "Impérial" },
  minTotal: { en: "min total", fr: "min au total" },
  min: { en: "min", fr: "min" },
  prep: { en: "Prep", fr: "Prépa" },
  cook: { en: "Cook", fr: "Cuisson" },
  restLabel: { en: "Rest", fr: "Repos" },
  viewOriginal: { en: "View original", fr: "Voir l'original" },
  notFound: { en: "Recipe not found", fr: "Recette introuvable" },
  optional: { en: "optional", fr: "facultatif" },
  favoritesOnly: { en: "Favorites", fr: "Favoris" },
  noFavorites: { en: "No favorites yet. Tap the heart on a recipe to save it.", fr: "Aucun favori. Touchez le cœur d'une recette pour la sauvegarder." },
  addFavorite: { en: "Add to favorites", fr: "Ajouter aux favoris" },
  removeFavorite: { en: "Remove from favorites", fr: "Retirer des favoris" },
} satisfies Record<string, Str>;

export function t(key: keyof typeof T, lang: Lang): string {
  return T[key][lang];
}
